__turbopack_export_value__({
  "card": "PharmacyCard-tsx-module-scss-module__y87WTW__card",
  "card__button": "PharmacyCard-tsx-module-scss-module__y87WTW__card__button",
  "card__buttonWrapper": "PharmacyCard-tsx-module-scss-module__y87WTW__card__buttonWrapper",
});
